export interface ProductTypeSalesUnits {
  unitOfMeasureId: string;
  unitOfMeasureKey: string;
  unitOfMeasureShortDescription: string;
  selected: boolean;
}
